<template>
<div>
    <div class="desktop cust-card bg-white">
        <div class="row nh">
            <b-col cols="5" class="p-3">
                <p class="font16 font-weight-bold">{{fromLanguage}} - {{toLanguage}} Interpreter <span v-if="hireStatus == 1">
                        <b-icon style="color:#F7B131" font-scale="0.9" icon="patch-check-fill"></b-icon>
                    </span> </p>

                <div class="font14 mb-3"  v-if="description">
                  <span :inner-html.prop="description | truncate(100)"></span>  
                </div>
                <p class="font14 tag text-capitalize font-weight-bold btn btn-outline-warning">
                    {{spec}}
                </p>

            </b-col>
            <b-col cols="4" class="bordered p-3">
                <p class="time-frame font10">
                    <strong> {{fromLanguage | truncate(10)}}</strong> <span class="text-black">with {{fromExperience}}
                        years experience</span>
                </p>
                <p class="time-frame font10">
                    <strong> {{toLanguage | truncate(10)}}</strong> <span class="text-black">with {{toExperience}}
                        years experience</span>
                </p>
                <p class="font12">
                    <b-icon style="color:#F7B131" font-scale="1.4" icon="geo"></b-icon> {{locationStatus}}
                </p>
                <router-link :to="{ name: torouteName, params: {id: routeId} }" class="action-btn btn btn-warning">{{btnText}}
                    <b-icon scale="0.8" icon="arrow-right"></b-icon>
                </router-link>
            </b-col>
            <b-col cols="3" class="bg_" v-bind:style='{ backgroundImage: "url(" + imgUrl + ")", }'></b-col>
        </div>
    </div>
    <div class="mobile cust-card bg-white">
        <div class="row nh-m">
            <b-col cols="12" class="p-3">
                <div class="row justify-content-between">
                    <p class="font14 font-weight-bold">{{fromLanguage}} - {{toLanguage}} Interpreter <span v-if="hireStatus == 1">
                            <b-icon style="color:#F7B131" font-scale="0.9" icon="patch-check-fill"></b-icon>
                        </span> </p>

                    <div class="bg_" v-bind:style='{ backgroundImage: "url(" + imgUrl + ")", }'></div>
                </div>
                <div class="font12 mb-1 mt-2" v-if="description">
                    {{description | truncate(150)}}
                </div>
            </b-col>
            <b-col cols="12" class="">
                <p class="time-frame font10">
                    <strong> {{fromLanguage | truncate(10)}}</strong> <span class="text-black">with {{fromExperience}}
                        years experience</span>
                </p>
                <p class="time-frame font10">
                    <strong> {{toLanguage | truncate(10)}}</strong> <span class="text-black">with {{toExperience}}
                        years experience</span>
                </p>
                <div class="mt-4">
                    <p class="font12 float-left">
                        <b-icon style="color:#F7B131" font-scale="1.4" icon="geo"></b-icon> {{locationStatus}}
                    </p>
                    <router-link :to="{ name: torouteName, params: {id: routeId} }" class="float-right btn btn-warning">{{btnText}}
                        <b-icon scale="0.9" icon="arrow-right"></b-icon>
                    </router-link>
                </div>
            </b-col>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: 'interpreter-card',
    props: [ 'description', 'torouteName', 'routeId', 'hireStatus', 'fromLanguage', 'toLanguage', 'spec', 'fromExperience', 'toExperience', 'locationStatus', 'btnText', 'imgUrl'],
}
</script>

<style lang="scss" scoped>
.action-btn {
    position: absolute;
    bottom: 20px
}
.tag{
     position: absolute;
    bottom: 3px
}

.bg_ {
    background-size: cover;
    background-position: center;
    border-radius: 0px 16px 16px 0px;

    @media screen and (min-device-width: 320px) and (max-device-width: 640px) and (-webkit-min-device-pixel-ratio: 1) {
        height: 51px;
        width: 45%;
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
    }

}

.nh {
    height: 14rem
}
.nh-m{
    height: 21rem;
}

.cust-card {
    box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.12);
    border-radius: 16px;
}

.cust-card:hover {
    border: 1px solid #f7b131;
}

.row {
    margin-left: 0 !important;
}

.btn.btn-outline-warning:not(:disabled):not(.disabled) {
    cursor: default !important
}

.btn-outline-warning:hover {
    color: #f7b131;
    background-color: #fff;
    border-color: #f7b131;
}

.time-frame {
    background: rgba(247, 177, 49, 0.15);
    border-radius: 16px;
    padding: 2px 13px;
    text-transform: uppercase;
    margin-top: 10px
}
</style>
